export default "__VITE_ASSET__ce7d4a27__"